import { createMesFeApp } from './bootstrap';

createMesFeApp().app.mount('#app');
